<div id="error-404" fxLayout="column" fxLayoutAlign="center center">
    <div class="content" fxLayout="column" fxLayoutAlign="center center">
        <div class="error-code">404</div>
        <div class="message mb-16">{{ 'NOT_FOUND_TEXT' | translate }}</div>
        <button class="delta-ma-primary-button my-8" [routerLink]="'/'">
            {{ 'Back to Home' | translate }}
        </button>
    </div>
</div>
